export const SENSITIVE_FIELDS = [
  'firstName',
  'lastName',
  'password',
  'identificationNumber',
  'email',
  'phone',
  'dateOfBirth',
  'identificationType',
  'country',
  'sex',
  'ethnicity',
];

export const REDACTED_TEXT = '[Filtered]';

const isArrayOfUnknown = (value: unknown): value is unknown[] => {
  return Array.isArray(value);
};

/**
 * Recursively redacts sensitive data in objects
 * @param data - Any data structure that might contain sensitive information
 * @returns The same data structure with sensitive information replaced with '[Filtered]'
 */
export const redactSensitiveData = <T>(data: T): T => {
  if (data === null || typeof data !== 'object') {
    return data;
  }

  if (isArrayOfUnknown(data)) {
    return data.map((item) => redactSensitiveData(item)) as unknown as T;
  }

  const result = { ...data } as Record<string, unknown>;

  for (const key in result) {
    if (result.hasOwnProperty(key)) {
      if (SENSITIVE_FIELDS.includes(key)) {
        result[key] = REDACTED_TEXT;
      } else if (typeof result[key] === 'object' && result[key] !== null) {
        result[key] = redactSensitiveData(
          result[key] as Record<string, unknown>,
        );
      }
    }
  }

  return result as unknown as T;
};
